
export default function createTreeNumberMap(module: any, m: { [index: number]: number }) {
    let cpp_map = new module.TreeNumberMap();

    for (const treeID in m) {
        const val = m[Number(treeID)];
        if (isNaN(val)) { continue; }
        const species = module.SpeciesID.from_integral(treeID);
        cpp_map.set(species, val);
    }

    return cpp_map;
}
